class ComplementaryProductsSwiper {
  constructor(container) {
    this.container = container;
    this.swiperId = container.getAttribute('id');
    this.productsPerPage = parseInt(container.dataset.productsPerPage) || 3;
    this.paginationStyle = container.dataset.paginationStyle || 'counter';
    this.totalProducts = container.querySelectorAll('.swiper-slide').length;
    
    this.init();
  }

  init() {
    // Don't initialize if there are no products or only one slide group
    if (this.totalProducts <= this.productsPerPage) {
      this.hideNavigation();
      return;
    }

    // Calculate responsive breakpoints
    const breakpoints = {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 12
      },
      750: {
        slidesPerView: Math.min(this.productsPerPage, 2),
        spaceBetween: 24
      },
      990: {
        slidesPerView: this.productsPerPage,
        spaceBetween: 24
      }
    };

    // Swiper configuration
    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: false,
      autoHeight: false,
      watchSlidesProgress: true,
      breakpoints,
      navigation: {
        nextEl: `.complementary-swiper-button-next`,
        prevEl: `.complementary-swiper-button-prev`,
      },
      on: {
        init: (swiper) => {
          this.updatePaginationCounter(swiper);
        },
        slideChange: (swiper) => {
          this.updatePaginationCounter(swiper);
        },
        breakpoint: (swiper) => {
          // Update pagination when breakpoint changes
          setTimeout(() => {
            this.updatePaginationCounter(swiper);
          }, 100);
        }
      }
    };

    // Add pagination configuration based on style
    if (this.paginationStyle === 'dots') {
      swiperConfig.pagination = {
        el: `#${this.swiperId} .complementary-swiper-pagination`,
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5
      };
      } else if (this.paginationStyle === 'numbers') {
      // For numbers pagination, we need to calculate based on slides per view
      const self = this;
      swiperConfig.pagination = {
        el: `#${this.swiperId} .complementary-swiper-pagination-numbers`,
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      };
    }

    // Initialize Swiper
    this.swiper = new Swiper(`#${this.swiperId}`, swiperConfig);
  }

  hideNavigation() {
    const navButtons = this.container.querySelectorAll('.complementary-swiper-button-prev, .complementary-swiper-button-next');
    const pagination = this.container.querySelectorAll('.complementary-swiper-pagination, .complementary-swiper-pagination-counter, .complementary-swiper-pagination-numbers');
    
    navButtons.forEach(button => button.style.display = 'none');
    pagination.forEach(pager => pager.style.display = 'none');
  }

  updatePaginationCounter(swiper) {
    if (this.paginationStyle === 'counter') {
      const counterEl = this.container.querySelector('.complementary-swiper-pagination-counter');
      if (counterEl) {
        const currentSlide = swiper.activeIndex + 1;
        const totalSlides = swiper.slides.length;
        const slidesPerView = Math.floor(swiper.params.slidesPerView);
        
        // Calculate current page based on slides per view
        const currentPage = Math.ceil(currentSlide / slidesPerView);
        const totalPages = Math.ceil(totalSlides / slidesPerView);
        
        counterEl.innerHTML = `
          <span class="slider-counter--current">${currentPage}</span>
          <span aria-hidden="true"> / </span>
          <span class="visually-hidden">of</span>
          <span class="slider-counter--total">${totalPages}</span>
        `;
      }
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Initialize all complementary product swipers when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const swiperContainers = document.querySelectorAll('.complementary-swiper');
  const swiperInstances = [];

  swiperContainers.forEach(container => {
    const instance = new ComplementaryProductsSwiper(container);
    swiperInstances.push(instance);
  });

  // Store instances globally for potential cleanup
  window.complementaryProductsSwipers = swiperInstances;
});

// Make the class globally available for dynamic initialization
window.ComplementaryProductsSwiper = ComplementaryProductsSwiper;

// Handle theme editor events
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const swiperContainers = event.target.querySelectorAll('.complementary-swiper');
    swiperContainers.forEach(container => {
      new ComplementaryProductsSwiper(container);
    });
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const swiperContainers = event.target.querySelectorAll('.complementary-swiper');
    swiperContainers.forEach(container => {
      // Find and destroy swiper instance if exists
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }
    });
  });
}
